import { useKV } from "@/hooks/use-kv-adapter";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Smiley, SmileySad, SmileyMeh } from "@phosphor-icons/react";

export function SentimentAnalysis() {
  const [sentiment] = useKV<any>("analytics-sentiment", {
    overall: 78,
    breakdown: { positive: 65, neutral: 25, negative: 10 },
    trends: [
      { topic: "Work-Life Balance", score: 85, trend: "up" },
      { topic: "Management Support", score: 72, trend: "stable" },
      { topic: "Growth Opportunities", score: 60, trend: "down" }
    ]
  });

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="md:col-span-2">
          <CardHeader>
            <CardTitle>Employee Sentiment</CardTitle>
            <CardDescription>Real-time pulse based on recent feedback</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-center py-8">
              <div className="relative w-40 h-40 flex items-center justify-center rounded-full border-8 border-slate-100 dark:border-slate-800">
                <div className="text-center">
                  <div className="text-4xl font-bold text-blue-600">{sentiment.overall}</div>
                  <div className="text-xs text-slate-500 uppercase tracking-wide">Score</div>
                </div>
                <svg className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="46" fill="none" stroke="#2563eb" strokeWidth="8" strokeDasharray={`${sentiment.overall * 2.89} 289`} />
                </svg>
              </div>
            </div>
            
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="flex justify-center mb-2"><Smiley className="w-6 h-6 text-green-500" /></div>
                <div className="font-semibold">{sentiment.breakdown.positive}%</div>
                <div className="text-xs text-slate-500">Positive</div>
              </div>
              <div>
                <div className="flex justify-center mb-2"><SmileyMeh className="w-6 h-6 text-amber-500" /></div>
                <div className="font-semibold">{sentiment.breakdown.neutral}%</div>
                <div className="text-xs text-slate-500">Neutral</div>
              </div>
              <div>
                <div className="flex justify-center mb-2"><SmileySad className="w-6 h-6 text-red-500" /></div>
                <div className="font-semibold">{sentiment.breakdown.negative}%</div>
                <div className="text-xs text-slate-500">Negative</div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Key Drivers</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            {sentiment.trends.map((item: any) => (
              <div key={item.topic} className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span>{item.topic}</span>
                  <span className={`font-medium ${
                    item.score >= 80 ? 'text-green-600' : 
                    item.score >= 60 ? 'text-amber-600' : 'text-red-600'
                  }`}>{item.score}</span>
                </div>
                <Progress value={item.score} className="h-1.5" />
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
